import { render, staticRenderFns } from "./AnnotatorItem.vue?vue&type=template&id=f813854e&"
import script from "./AnnotatorItem.vue?vue&type=script&lang=js&"
export * from "./AnnotatorItem.vue?vue&type=script&lang=js&"
import style0 from "./AnnotatorItem.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports